import { LEGACY_ASSIGN_TO_HUMAN } from '../constants';
import type { AssignActionData, InstructionActionData } from '../types';

/**
 * An action as the editor keeps it: the legacy Assign to User (`KIM_ASSIGN_TO_HUMAN`) reads as an
 * Assign to Agent with the same agent, and an Assign with no target acts on the agent. An Unassign
 * with no target is left as it is: the brand's escalation policy picks it. Saving the instruction
 * then writes the current shape.
 */
export function upgradeLegacyAction(action: InstructionActionData): InstructionActionData {
  if (action.type === LEGACY_ASSIGN_TO_HUMAN) {
    const assign: AssignActionData = {
      type: 'KIM_ASSIGN',
      target: 'agent',
      agentId: action.agentId ?? '',
      agentName: action.agentName ?? '',
      agentEmail: action.agentEmail ?? ''
    };
    return action.agentProvider ? { ...assign, agentProvider: action.agentProvider } : assign;
  }
  if (action.type === 'KIM_ASSIGN' && action.target !== 'sentinel') {
    return action.target === 'agent' ? action : { ...action, target: 'agent' };
  }
  return action;
}
